module.exports = __webpack_public_path__ + "img/p29241.797dbe70.jpg";